import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as actionConstants from 'utils/ActionConstants';

export const createProfile = async form => {
    return await Api.createProfile(form);
};

// get profile
export const getProfile = async profileId => {
    return await Api.createProfile(profileId);
};



// WEBPACK FOOTER //
// ./src/modules/profile/ProfileActions.js